export default "__VITE_ASSET__DG6CHKVE__"